import React from "react";
import { useViewport } from "@bookingcom/bui-react";
import { DESKTOP_SIDEBAR_WIDTH_SMALLER } from "../../../../constants.js";
import Frame from "../../Frame/index.js";
const Sidebar = (props) => {
    const { children, p, pt, pr, pb, pl, className } = props;
    const { isSmall, isLarge } = useViewport();
    return (React.createElement(Frame, { className: className, direction: "column", p: p, pt: pt, pr: pr, pb: pb, pl: pl, attributes: {
            style: {
                ...props.style,
                flexShrink: 0,
                width: isSmall || !isLarge ? "100%" : DESKTOP_SIDEBAR_WIDTH_SMALLER,
                marginTop: undefined
            }
        } }, children));
};
export default Sidebar;
